export default class BookLoftForm {
  constructor(form, i, data) {
    this.form = form;
    this.i = i;
    this.baseUrl = "https://reservations.verticalbooking.com/premium/index2.html?tot_camere=1&id_stile=20589&lingua_int=ita&id_albergo=27310&dc=3110";
    this.months = [
      ["jan", "january", "gen", "gennaio"],
      ["feb", "february", "feb", "febbraio"],
      ["mar", "march", "mar", "marzo"],
      ["apr", "april", "apr", "aprile"],
      ["may", "may", "mag", "maggio"],
      ["jun", "june", "giu", "giugno"],
      ["jul", "july", "lug", "luglio"],
      ["aug", "august", "ago", "agosto"],
      ["sep", "september", "set", "settembre"],
      ["oct", "october", "ott", "ottobre"],
      ["nov", "november", "nov", "novembre"],
      ["dec", "december", "dec", "dicembre"]
    ];
    this.labels = data?.data?.hotelDatepickerLabels;
  }

  init() { 
    this._handleInputDateWidth();

    if (this.form.querySelector(".js-checkin-checkout-dates")) {
      this.form.querySelector(".js-checkin-checkout-dates").setAttribute("id", this.form.querySelector(".js-checkin-checkout-dates").getAttribute("id") + `-${this.i}`);
      this._initHotelDatePicker(this.form.querySelector(".js-checkin-checkout-dates"));
    }    

    this._initQuantityButtons();

    this.form.querySelector(".js-btn-check-form")?.addEventListener("click", (e) => {
      e.preventDefault();
      
      const formData = new FormData(this.form);
      const { formOk, data, errors } = this._checkBookLoftForm(formData);

      if (formOk) {
        window.open(
          `${this.baseUrl}&tot_adulti=${data.nAdults}&tot_bambini=${data.nKids}&gg=${data.dateCheckIn[0]}&mm=${data.dateCheckIn[1]}&aa=${data.dateCheckIn[2]}&ggf=${data.dateCheckOut[0]}&mmf=${data.dateCheckOut[1]}&aaf=${data.dateCheckOut[2]}`,
          "_blank"
        );
      } else {
        console.log(errors);
      }
    });
  }

  _handleInputDateWidth() {
    // patch date inputs width...
    let currentWidth = window.innerWidth;
    let resizing;

    window.addEventListener("resize", (e) => {
      if (window.innerWidth < 992) {
        if (window.innerWidth !== currentWidth) {
          this.form.querySelectorAll("input[type='date']")?.forEach((input) => {
            input.removeAttribute("style");
          });         
        }

        clearTimeout(resizing);      
        resizing = setTimeout(() => {
          if (window.innerWidth !== currentWidth) {
            this.form.querySelectorAll("input[type='date']")?.forEach((input) => {
              input.style.width = `${input.closest(".single-input").offsetWidth}px`;
            });         
          }
        }, 250);
      }      
    });

    if (window.innerWidth < 992) {
      this.form.querySelectorAll("input[type='date']")?.forEach((input) => {
        input.style.width = `${input.closest(".single-input").offsetWidth}px`;
      });
    }
  }

  _initQuantityButtons() {
    const inputs = this.form.querySelectorAll(".js-input-quantity");
    inputs?.forEach((input) => {
      const btnDecrease = input.querySelector(".js-quantity-decrease");
      const btnIncrease = input.querySelector(".js-quantity-increase");
      const inputEl = input.querySelector(".js-quantity");      
      
      if (inputEl) {
        btnDecrease?.addEventListener("click", (e) => {
          e.preventDefault();
          if (inputEl.value > 0) {
            inputEl.value = parseInt(inputEl.value--) > 0 ? parseInt(inputEl.value--) : 0;         
          }                  
        });

        btnIncrease?.addEventListener("click", (e) => {
          e.preventDefault();
          inputEl.value = parseInt(inputEl.value++) >= 0 ? parseInt(inputEl.value++) : 0;         
        });        
      }      
    });
  }

  _checkBookLoftForm(formData) {
    let formOk = false;
    const data = {      
      nAdults: formData.get("n-adults"),
      nKids: formData.get("n-kids")
    }
    
    // se non è zuppa è pan bagnato...
    if (this.form.querySelector(".js-checkin-checkout-dates")) {
      const { checkinArr, checkoutArr } = this._getCheckinCheckout(formData.get("checkin-checkout-dates"));
      data.dateCheckIn = checkinArr;
      data.dateCheckOut = checkoutArr;

    } else {
      data.dateCheckIn = this._parseDateStrNumberToArr(formData.get("loft-check-in"));
      data.dateCheckOut = this._parseDateStrNumberToArr(formData.get("loft-check-out"));      
    }
    
    const errors = new Object();

    const inputChekIn = this.form.querySelector("[name='loft-check-in']");
    const inputCheckOut = this.form.querySelector("[name='loft-check-out']");
    const inputAdults = this.form.querySelector("[name='n-adults']");

    if (data.hasOwnProperty("dateCheckIn")) {
      if (!data.dateCheckIn) {
        errors.dateCheckIn = "checkIn val is empty";
        if (inputChekIn) {
          inputChekIn.style.border = "1px solid red";
        }

      } else {
        inputChekIn?.removeAttribute("style");
      }
    }
        
    if (data.hasOwnProperty("dateCheckOut")) {
      if (!data.dateCheckOut) {
        errors.dateCheckOut = "checkOut val is empty";
        if (inputCheckOut) {
          inputCheckOut.style.border = "1px solid red";
        }

      } else {
        inputCheckOut?.removeAttribute("style");
      }
    }    
    
    if (!data.nAdults) {
      errors.nAdults = "nAdults is empty";      
      if (inputAdults) {
        inputAdults.style.border = "1px solid red";
      }
      
    } else {
      if (parseInt(data.nAdults) < 1) {
        errors.nAdults = "nAdults val is below 1";
        if (inputAdults) {
          inputAdults.style.border = "1px solid red";
        }
      
      } else {
        inputAdults?.removeAttribute("style");
      }
    }
    
    if (!data.nKids) {
      data.nKids = 0;
      
    } else {
      if (parseInt(data.nKids) < 0) {
        errors.nKids = "nKids is below 0"; 
      }
    }
    
    if (Object.keys(errors).length < 1) {
      formOk = true;
    }
    
    return { formOk, data, errors };
  }

  _initHotelDatePicker(input) {    
    if (!this.labels) {
      console.error("Hotel Datepicker labels data is undefined!");
      return;
    }
    
    const datepicker = new HotelDatepicker(input, {
        inline: true,
        clearButton: true,
        format: 'dddd D MMM YYYY',
        startOfWeek: 'monday',
        i18n: {
            selected: this.labels["selected"],
            night: this.labels["night"],
            nights: this.labels["nights"],
            button: this.labels["button"],
            clearButton: this.labels["clearButton"],
            'checkin-disabled': this.labels["checkin-disabled"],
            'checkout-disabled': this.labels["checkout-disabled"],
            'day-names-short': this.labels["day-names-short"],
            'day-names': this.labels["day-names"],
            'month-names-short': this.labels["month-names-short"],
            'month-names': this.labels["month-names"],
            'error-more': this.labels["error-more"],
            'error-more-plural': this.labels["error-more-plural"],
            'error-less': this.labels["error-less"],
            'error-less-plural': this.labels["error-less-plural"],
            'info-more': this.labels["info-more"],
            'info-more-plural': this.labels["info-more-plural"],
            'info-range': this.labels["info-range"],
            'info-range-equal': this.labels["info-range-equal"],
            'info-default': this.labels["info-default"],
            'aria-application': this.labels["aria-application"],
            'aria-selected-checkin': this.labels["aria-selected-checkin"],
            'aria-selected-checkout': this.labels["aria-selected-checkout"],
            'aria-selected': this.labels["aria-selected"],
            'aria-disabled': this.labels["aria-disabled"],
            'aria-choose-checkin': this.labels["aria-choose-checkin"],
            'aria-choose-checkout': this.labels["aria-choose-checkout"],
            'aria-prev-month': this.labels["aria-prev-month"],
            'aria-next-month': this.labels["aria-next-month"],
            'aria-close-button': this.labels["aria-close-button"],
            'aria-clear-button': this.labels["aria-clear-button"],
            'aria-submit-button': this.labels["aria-submit-button"]
        }
    });
  }
  
  _getCheckinCheckout(checkinCheckoutString) {
    const checkinArr = this._parseDateStrToArr(checkinCheckoutString.split("-")[0]);
    const checkoutArr = this._parseDateStrToArr(checkinCheckoutString.split("-")[1]);
    
    return { checkinArr, checkoutArr };
  }

  _parseDateStrToArr(str) {
    if (str) {
      const strArr = str.split(" ").filter((word) => word.length);
      let i = 0;      
      this.months.forEach(month => month.includes(strArr[2].toLowerCase()) ? i = this.months.indexOf(month) + 1 : "");

      return [
        parseInt(strArr[1]), // j
        i, // month
        parseInt(strArr[3]) // year
      ];
    }

    return false; 
  }

  _parseDateStrNumberToArr(str) {
    if (str) {
      const strArr = str.split("-");

      return [
        parseInt(strArr[2]), // j 
        parseInt(strArr[1]), // month
        parseInt(strArr[0]) // year
      ];
    }
  }
}